const component = "draggable-site-sections-tree";

export const draggableSiteSectionsTree = {
  component,
  virtualizedTree: `${component}/virtualized-tree`,
  item: {
    padding: `${component}/item/padding`,
    section: `${component}/item/section`,
    dotsGripIcon: `${component}/item/dots-grip-icon`,
    toggleExpandIcon: `${component}/item/toggle-expand-icon`,
    sectionName: `${component}/item/section-name`,
    sectionChildrenCount: `${component}/item/section-children-count`,
  },
};
